import type { AuthUser } from '../types/auth.types';

const normalize = (value?: string | null) =>
  value ? value.toLowerCase() : null;

export function hasTenantRole(
  user: AuthUser | null | undefined,
  role: string
): boolean {
  if (!user || !role) {
    return false;
  }

  const needle = role.toLowerCase();

  if (user.gtcRoles?.some(r => normalize(r) === needle)) {
    return true;
  }
  if (user.gtcTenantAssignment?.roles?.some(r => normalize(r) === needle)) {
    return true;
  }
  if (normalize(user.gtcTenantAssignment?.role) === needle) {
    return true;
  }

  return false;
}

export function hasAnyTenantRole(
  user: AuthUser | null | undefined,
  roles: string[] | undefined
): boolean {
  if (!roles || roles.length === 0) {
    return false;
  }

  return roles.some(role => hasTenantRole(user, role));
}

export function hasAllTenantRoles(
  user: AuthUser | null | undefined,
  roles: string[] | undefined
): boolean {
  if (!roles || roles.length === 0) {
    return false;
  }

  return roles.every(role => hasTenantRole(user, role));
}
